import { render } from "./typingHeader.vue?vue&type=template&id=9034954e&scoped=true&ts=true"
import script from "./typingHeader.vue?vue&type=script&lang=ts"
export * from "./typingHeader.vue?vue&type=script&lang=ts"

import "./typingHeader.vue?vue&type=style&index=0&id=9034954e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9034954e"]])

export default __exports__